import { Routes } from '@angular/router';
import { AppRoute } from '@app/app-routes.enum';
import { unauthenticatedGuard } from '@app/core/authentication/guards/unauthenticated.guard';
import { authenticatedGuard } from '@app/core/authentication/guards/authenticated.guard';
import { authInitGuard } from '@app/core/authentication/guards/auth-init.guard';
import { provideAuthStore } from '@app/core/authentication/store/auth/auth.store';
import { provideUserMeStore } from '@app/main/user-me/store/user-me/user-me.store';
import { provideAppContextStore } from '@app/core/store/app-context/app-context.store';
import { buildInfoResolver } from '@app/core/build-info/resolvers/build-info.resolver';
import { userMeGuard } from '@app/main/user-me/guards/user-me.guard';
import { provideCoordinateSystemsStore } from '@app/core/coordinate-systems/store/coordinate-systems/coordinate-systems.store';
import { coordinateSystemsGuard } from '@app/core/coordinate-systems/guards/coordinate-systems.guard';
import { envFeatureGuardConstructor } from '@app/core/env-feature/guards/env-feature.guard';
import { EnvType } from 'src/environments/common/environment-type.enum';
import { mockEnabledGuard } from '@mock/guards/mock-enabled.guard';

export const routes: Routes = [
  {
    path: '',
    providers: [provideAuthStore(), provideAppContextStore()],
    canMatch: [authInitGuard],
    resolve: {
      buildInfoLoaded: buildInfoResolver,
    },
    children: [
      {
        path: AppRoute.Auth,
        loadChildren: () => import('./core/authentication/auth.routes').then(m => m.authRoutes),
        canActivate: [unauthenticatedGuard],
      },
      {
        path: AppRoute.ComponentList,
        loadChildren: () => import('./core/components-list/components-list.routes').then(m => m.componentsListRoutes),
        canMatch: [envFeatureGuardConstructor([EnvType.Development, EnvType.Test, EnvType.Stage])],
      },
      {
        path: AppRoute.Report,
        loadChildren: () =>
          import('./main/leak-detection/pages/report-placeholder/report-placeholder.routes').then(
            m => m.reportPlaceholderRoutes
          ),
        canActivate: [authenticatedGuard, mockEnabledGuard],
        canMatch: [mockEnabledGuard],
      },
      {
        path: AppRoute.Base,
        loadChildren: () => import('./main/main.routes').then(m => m.mainRoutes),
        canActivate: [authenticatedGuard, userMeGuard, coordinateSystemsGuard],
        canMatch: [authenticatedGuard],
        providers: [provideUserMeStore(), provideCoordinateSystemsStore()],
      },
      {
        path: '**',
        redirectTo: AppRoute.Base,
      },
    ],
  },
];
